module.exports = __webpack_public_path__ + "static/media/baseball.e59fe4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/baseball.jpg
// module id = 3563
// module chunks = 0